/**
 * @Author: zb
 * @LastEditors: Do not edit
 * @Date: 2019-08-09 16:02:07
 * @LastEditTime: 2019-08-16 11:23:42
 * @Version: 1.0
 * @Description: selectCondition组件的可混合对象
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks: 备注
 */
import { DatabaseUtil } from '@/utils/databaseUtils'
import { getArea, getDict } from '@/api/common'
const dataBase = new DatabaseUtil()

export default {
  methods: {
    /* 获取地址 */
    getArea() {
      if (dataBase.localStorageUtil.has('area')) {
        return new Promise(resolve => {
          resolve(JSON.parse(dataBase.localStorageUtil.get('area')))
        })
      }

      return getArea()
        .then(data => {
          dataBase.localStorageUtil.set('area', JSON.stringify(data.result))
          return data.result
        })
        .catch(error => {
          console.error(error)
        })
    },
    // 获取货源类型
    getGoodsType() {
      if (dataBase.sessionStorageUtil.has('goodsType')) {
        return new Promise(resolve => {
          resolve(JSON.parse(dataBase.sessionStorageUtil.get('goodsType')))
        })
      }

      return getDict('goodsType')
        .then(data => {
          dataBase.sessionStorageUtil.set('goodsType', data.result)
          return JSON.parse(data.result)
        })
        .catch(err => {
          console.error(err)
        })
    },
    // 地址数据转换处理
    formatArea(parent, data) {

    },
    expandChange() {
      setTimeout(function() {
        var alist = document.getElementsByClassName('el-radio__original')
        if (alist) {
          for (var idx = 0; idx < alist.length; idx++) {
            var mya = alist[idx]
            mya.style.cssText =
                'width:160px;height:34px;z-index:1;top:-10px;cursor:inherit'
          }
        }
      }, 300)
    },
    cleanModal(modal) {
      for (const key in modal) {
        if (Object.prototype.toString.call(modal[key]).indexOf('Array') !== -1) {
          modal[key] = []
        } else {
          modal[key] = ''
        }
      }
    }
  }
}
